import Cookies from 'js-cookie';
export const saveCandidateJustLoggedInCookie = () => {
    const oneMinute = 1 / 24 / 60;
    Cookies.set('CANDIDATE_JUST_LOG_IN', '1', { expires: oneMinute });
};
//# sourceMappingURL=cookies.js.map